const permissions = {
  static: [
    "route:contents:preview",
    "route:contents:videos:preview",
    "route:contents:cdocs:preview",
    "route:contents:roadmaps:preview",
    "route:contents:variety:preview",
    "route:contents:images:preview",
    "route:contents:slideshows:preview",

    "route:cohort:preview",
    "route:cohort:list:preview",
    "route:cohort:events:preview",
    "route:cohort:customize:preview",

    "route:calificate:preview",
    "route:calificate:evaluate:preview",
    "route:calificate:criterions:preview",
    "route:calificate:criterions:create",
    "route:contents:listens:preview",
    "route:calificate:criterions:edit",
    "route:calificate:subcriterion:preview",
    "route:calificate:subcriterion:create",
    "route:calificate:subcriterion:edit",
    "route:contents:roadmaps:preview",

    "route:dashboard:preview",
    "route:dashboard:cohorts:preview",
    "route:dashboard:cohorts:cohort:preview",
    "route:dashboard:cohorts:individual:preview",

    "route:management:preview",
    "route:management:collaborators:preview",
    "route:management:collaborators:invitation:preview",
    "route:management:collaborators:management:preview",
    "route:management:collaborators:customize:preview",
    "route:management:marketplace:preview",
    "route:management:calendar:preview",
    "route:notification:preview",

    "route:calendar:preview",

    "route:talents:preview",
    "route:talents:edit",
    "route:talents:create",

    "route:education:preview",
    "route:education:edit",
    "route:education:create",

    "route:cohort:preview",
    "route:cohort:edit",
    "route:cohort:create",

    "route:cdocs:list",

    "route:analytics:preview",
    "route:analytics:edit",
    "route:analytics:create",

    "route:marketplace:preview",
    "route:marketplace:edit",
    "route:marketplace:create",

    "route:contents:preview",

    "route:certificate:preview",
    "route:certificate:new",
    "route:certificate:edit",
    "route:certificate:management:preview",
    "route:certificate:templates:preview",

    "route:notification:preview",
    "route:notification:new",
    "route:notification:edit",

    "route:template:preview",
    "route:template:new",
    "route:template:edit",

    "route:config:preview",
    "route:config:new",
    "route:config:edit",

    "route:forms:preview",
    "route:forms:new",
    "route:forms:edit",

    "route:settings:preview",
  ],
  dynamic: {
    "op:edit:state": ({ status }) => {
      if (!status) return false;
      return ["requested", "pending", "inProgress", "done"].includes(status);
    },
  },
};

export default permissions;
